export default __webpack_public_path__ + "static/media/Now-Medium.5246d1ad.otf";